import { PUBLIC_ORIGIN } from "./CanonicalUrl";

export function slugifyEventTitle(value = "") {
  const slug = String(value)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/['’]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80)
    .replace(/-+$/g, "");

  return slug || "event";
}

export function eventDetailPath(event = {}) {
  const id = String(event.id || "").trim();
  if (!id) return "";

  const titleSlug = slugifyEventTitle(event.slug || event.title || event.name);
  return `/events/${titleSlug}--${encodeURIComponent(id)}`;
}

export function eventIdFromDetailParam(value = "") {
  const segment = String(value || "").replace(/^\/+|\/+$/g, "");
  const separatorIndex = segment.indexOf("--");
  const encodedId = separatorIndex >= 0
    ? segment.slice(separatorIndex + 2)
    : segment;

  if (!encodedId) return "";

  try {
    return decodeURIComponent(encodedId);
  } catch {
    return "";
  }
}

export function eventCanonicalUrl(event = {}) {
  const path = eventDetailPath(event);
  return path ? `${PUBLIC_ORIGIN}${path}` : "";
}
